import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { OrganizationsState } from '../organizations/OrganizationsState';

/**
 * Whether marking something private means anything to this user.
 *
 * The private/public distinction on a care map exists so a family owner can keep some of the record
 * back from the relatives and viewers they have invited. An agency's staff are the only people with
 * accounts on their clients' records: the clients themselves and their families do not sign in, so
 * there is no audience to withhold anything from. Every privacy control shown to agency staff is
 * therefore a choice with no consequence, and the labels are noise on a screen they read all day.
 *
 * This hides the controls rather than changing what is stored, so the underlying flags keep their
 * values and nothing changes for the consumer families who do have an audience. Retiring the concept
 * for organizations properly is a larger piece of work.
 */
export const useHasPrivacyAudience = (): boolean => {
    const organizations = useInstance(OrganizationsState);
    useSubscription(() => organizations);

    return !organizations.isOrgTeamMember();
};
